import { ChangeEvent } from 'react'

export const onlyDigits = (event: ChangeEvent<HTMLInputElement>) => {
  if (event.target instanceof HTMLInputElement) {
    event.target.value = event.target.value.replace(/\D/g, '')
  }
}
